import { ParentContext } from 'global/cnr/contexts/ParentContext'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import { _longPressTypes, LPW } from 'global/wrappers/LongPressWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useSportsAccess } from 'projectSpecific/sports/useHelpers/useSportsAccess'
import React, { useContext, useEffect, useState } from 'react'
import { Form, Icon, Label } from 'semantic-ui-react'

const _sportsAccessTypes = {
  full: 'full',
  edit: 'edit',
  scores: 'scores',
  sport: 'sport',
  school: 'school',
}

export const AccessSquares = ({ _teamAccess, _currentTeam, _accessByEmail, _accessByTeams }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { database_fns } = fns ?? {}
  const { pathViews } = paps_state ?? {}

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { schools: schools_district, sports: sports_district } = sportsDistrict_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { sportsAccess_teams, teams_info } = sportsSeason_state ?? {}
  const { teams: access_teams } = sportsAccess_teams ?? {}

  const [activeItem, setActiveItem] = useState()
  const [accessByEmail, setAccessByEmail] = useState()
  const [accessByTeams, setAccessByTeams] = useState()

  const [showSports, setShowSports] = useState()
  const [showSchools, setShowSchools] = useState()

  const [activeLongPressItem, setActiveLongPressItem] = useState()

  const [teamsAccess, setTeamsAccess] = useState(access_teams)
  const [teamAccess, setTeamAccess] = useState()

  const [currentEmailAccess, setCurrentEmailAccess] = useState()
  const [currentTeam, setCurrentTeam] = useState()

  const { updating: updating_access, allowAccessUpdate, getAccess, updateAccess } = useSportsAccess()

  useEffect(() => {
    console.log('_accessByEmail', _accessByEmail)
    const cb_access = ({ parentKey, teams, accessByEmail, accessByTeams }) => {
      setAccessByEmail(accessByEmail)
      setAccessByTeams(accessByTeams)
    };
    if (_accessByEmail && _accessByTeams) {
      setAccessByEmail(_accessByEmail)
      setAccessByTeams(_accessByTeams)
      return;
    }
    console.log('GET ACCESS')
    getAccess({ callback: cb_access })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!_currentTeam) return;
    setCurrentTeam(_currentTeam)
  }, [_currentTeam]);

  useEffect(() => {
    if (!_teamAccess) return;
    setTeamAccess(_teamAccess)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_teamAccess]);

  const handle_update = () => {
    // const _teamAccess = accessByTeams?.[currentTeam?._itemKey]
    console.log('handle_update', currentTeam._itemKey, accessByEmail)
    const matches = _.pickBy(
      accessByEmail,
      item => item.teams?.[currentTeam._itemKey]
    );
    updateAccess({ teamAccess, teamKey: currentTeam._itemKey, accessByTeam: _teamAccess, accessByEmail: matches })

  }
  const handleChange = (e, i) => { setCurrentEmailAccess(i.value) }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !emailRegex.test(email);
  };

  const handleAddToList = () => {

    const _teamAccess = teamAccess ? _.cloneDeep(teamAccess) : []
    const _teamsAccess = teamsAccess ? _.cloneDeep(teamsAccess) : []
    const _accessByEmail = accessByEmail ? _.cloneDeep(accessByEmail) : {}

    if (!_accessByEmail?.[currentEmailAccess]) {
      _accessByEmail[currentEmailAccess] = {
        name: currentEmailAccess,
        teams: {
          [currentTeam._itemKey]: {
            accessLevel: 'scores'
          }
        }
      }
    }

    _teamsAccess[currentTeam._itemKey] = _teamAccess

    setTeamAccess(_teamAccess)
    setTeamsAccess(_teamsAccess)
    setAccessByEmail(_accessByEmail)

    // const _accessByTeams = accessByTeams ? _.cloneDeep(accessByTeams) : {}
    // const _accessByTeam = _accessByTeams?.[currentTeam._itemKey]
    // _accessByTeam.push({
    //   accessLevel: 'scores',
    //   name: currentAccessItem
    // })
    setAccessByTeams(_accessByTeams)
  }

  const item_add = () => <Form.Input
    fluid
    value={currentEmailAccess}
    onChange={handleChange}
    action={{ disabled: validateEmail(currentEmailAccess), color: 'blue', icon: 'check', onClick: () => { handleAddToList() } }}
  />


  const footer_item = () => {
    return <UiSaveButtons
      save={{
        oc: handle_update,
        caption: 'Save Access',
        color: _.isEmpty(teamAccess) ? 'grey' : allowAccessUpdate ? 'green' : 'teal'
      }}
    />
  }

  const lbl_icn_check = (value, checked, width, oc) => <Label
    size='mini'
    style={{ flex: 1, textAlign: 'center' }}
    onClick={() => { oc && oc(value) }}
  >
    <Icon
      name={checked ? 'check circle outline' : 'circle outline'}
      color={checked ? 'green' : 'grey'} />{_.startCase(value)}
  </Label>

  const lbl_icn_count = (value, checked, width, oc) => <Label
    size='mini'
    style={{ flex: 1, textAlign: 'center' }}
    onClick={() => { oc && oc(value) }}
  >
    <Icon
      name={checked ? 'check circle outline' : 'circle outline'}
      color={checked ? 'green' : 'grey'} />{_.startCase(value)}
  </Label>


  const lpw = (content, type, longPressItem) => {
    const handleLp = () => {
      switch (type) {
        case _sportsAccessTypes.sport:
          setShowSports(!showSports)
          break;
        case _sportsAccessTypes.school:
          setShowSchools(!showSchools)
          break;
      }
      setActiveLongPressItem(longPressItem)
    }
    return <LPW
      longPressType={_longPressTypes.default}
      handleOnPress={handleLp}
    >
      {content}
    </LPW>
  }

  const fnAlt_access = (item) => {

    const { name } = item ?? {}
    const _accessByEmail = accessByEmail ? _.cloneDeep(accessByEmail) : {}
    const accessBy_email = _accessByEmail?.[name] || {}
    const { teams, sports, schools } = accessBy_email ?? {}

    console.log('item', item)

    const _team = teams?.[currentTeam?._itemKey]
    const { accessLevel: accessLevel_team } = _team ?? {}

    const oc = (_accessLevel) => {
      const _accessByEmail = accessByEmail ? _.cloneDeep(accessByEmail) : {}
      const _accessBy_email = _accessByEmail?.[name] || {}

      switch (_accessLevel) {
        case _sportsAccessTypes.school:
          const schoolKey = _.findKey(schools_district, { name: currentTeam?.name })
          if (!_accessBy_email.schools) { _accessBy_email.schools = {} }
          _accessBy_email.schools[schoolKey] = {
            accessLevel: 'scores'
          }
          break;
        case _sportsAccessTypes.sport:
          if (!_accessBy_email.sports) { _accessBy_email.sports = {} }
          _accessBy_email.sports[pathViews.sports] = {
            accessLevel: 'scores'
          }
          break;
        default:

      }

      setAccessByEmail(_accessByEmail)

    }

    return <div style={{ display: 'flex', columnGap: '.5em', width: '340px', justifyContent: 'space-between' }}>
      {lbl_icn_check(_sportsAccessTypes.full, accessLevel_team === _sportsAccessTypes.full, 80, oc)}
      {lbl_icn_check(_sportsAccessTypes.edit, accessLevel_team === _sportsAccessTypes.edit, 80, oc)}
      {lbl_icn_check(_sportsAccessTypes.scores, accessLevel_team === _sportsAccessTypes.scores, 80, oc)}
      {lpw(lbl_icn_count(_sportsAccessTypes.sport, !_.isEmpty(sports), 80, oc), _sportsAccessTypes.sport, item)}
      {lpw(lbl_icn_count(_sportsAccessTypes.school, !_.isEmpty(schools), 80, oc), _sportsAccessTypes.school, item)}
    </div>
  }

  const wrapper_access = () => {
    if (teamAccess) {
      _.forEach(teamAccess, t => {
        t.caption = t.name
      })
    }
    // const _teamAccess = accessByTeams?.[currentTeam?._itemKey]

    const oc = (value) => setActiveItem(value.name)
    const matches = _.pickBy(
      accessByEmail,
      item => item.teams?.[currentTeam._itemKey]
    );

    return <Wrapper
      header={item_add()}
      content={<ItemMenuSquares
        menuItems={_.sortBy(matches, 'name')}
        imsType={_imsTypes.inline}
        keepCaption={true}
        fn_altContent={fnAlt_access}
        onClick={oc}
        activeItem={activeItem}
        noItemIcon={true}
      />}
      wrapperType={wrapperTypes.padded}
      updating={updating_access}
      footer={footer_item()}
      noItemIcon={true}
    >
    </Wrapper>
  }

  return wrapper_access()

}
